// extracted by mini-css-extract-plugin
export default {"clone-img":"CloneImg_clone-img__zo1wQ","clone-spn":"CloneImg_clone-spn__rRg3G"};